var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEntryDoorIcon = function SvgEntryDoorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#entryDoorIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.558.851H12.38l.227 18.742-11.05 2.715z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.938,
    d: "M21.313 7.003a.7.7 0 0 1-.395-.11c-.105-.07-.164-.165-.164-.265V1.373H1.181a.7.7 0 0 1-.395-.11C.68 1.193.622 1.097.622.998c0-.1.059-.195.164-.266a.7.7 0 0 1 .395-.11h20.132c.149 0 .29.04.396.11.105.07.163.166.163.266v5.63c0 .1-.058.195-.163.265a.7.7 0 0 1-.396.11Zm0 16.141H1.181a.7.7 0 0 1-.395-.11c-.105-.07-.164-.166-.164-.265V19.39c0-.1.059-.195.164-.265a.7.7 0 0 1 .395-.11c.149 0 .29.04.396.11.105.07.164.166.164.265v3.003h19.013v-5.255c0-.1.059-.195.164-.265a.7.7 0 0 1 .395-.11c.149 0 .29.04.396.11.105.07.163.165.163.265v5.63c0 .1-.058.195-.163.266a.7.7 0 0 1-.396.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.938,
    d: "M1.171 23.144a.7.7 0 0 1-.388-.11c-.103-.07-.16-.166-.16-.265V.998c0-.1.057-.195.16-.266a.7.7 0 0 1 .388-.11h10.985c.146 0 .286.04.389.11s.16.166.16.266v18.768a.3.3 0 0 1-.093.208.56.56 0 0 1-.247.137L1.38 23.114a.8.8 0 0 1-.209.03Zm.55-21.771v20.84l9.886-2.703V1.373z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.938,
    d: "M11.065 12.381c-.1 0-.195-.02-.266-.055-.07-.035-.11-.083-.11-.133v-.374c0-.05.04-.098.11-.133a.6.6 0 0 1 .266-.055c.1 0 .195.02.265.055s.11.083.11.133v.374c0 .05-.04.098-.11.133a.6.6 0 0 1-.265.055Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.788,
    d: "M18.67 15.043a.32.32 0 0 1-.209-.082l-3.153-2.838a.315.315 0 0 1 0-.467l3.153-2.838a.316.316 0 1 1 .423.467l-2.895 2.604 2.895 2.605a.315.315 0 0 1-.208.549z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.788,
    d: "M22.888 12.205h-7.026a.23.23 0 0 1-.177-.092.36.36 0 0 1-.074-.223.36.36 0 0 1 .074-.223.23.23 0 0 1 .177-.093h7.026c.066 0 .13.033.177.093a.36.36 0 0 1 .074.223.36.36 0 0 1-.074.223.23.23 0 0 1-.177.092Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "entryDoorIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgEntryDoorIcon as ReactComponent };